import React from "react";

import {Container} from "@pg-design/grid-module";
import {mb, ph} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../../app/components/breadcrumbs/BreadcrumbsItem";
import {getOfferTypeNamePluralCapital} from "../../../offer/helpers/OfferType";
import {OfferType} from "../../../offer/types/OfferType";
import {Country} from "../../../region/types/Country";
import {SiteMapBox} from "../../components/SiteMapBox";
import {SiteMapHeading} from "../../components/SiteMapHeading";
import {SiteMapSubregionList} from "../../components/SiteMapSubregionList";
import {useRegions} from "../../hooks/use_regions";
import {offerTypeUrl} from "../../utils/offer_type_url";

interface IProps {
    offerType: OfferType;
}

export const SiteMapOffersType = (props: IProps) => {
    const {domesticRegions, abroadRegions} = useRegions();

    return (
        <Container>
            <Breadcrumbs homePageUrl={rpAppLink.base()}>
                <BreadcrumbsItem name="Mapa strony" position="2" url={rpAppLink.siteMap.base()} />
                <BreadcrumbsItem
                    isLinkingToCurrentLocation
                    name={`Mapa strony - ${getOfferTypeNamePluralCapital(props.offerType)}`}
                    position="3"
                    url={offerTypeUrl(props.offerType)}
                />
            </Breadcrumbs>

            <article>
                <SiteMapHeading>{`Mapa strony - ${getOfferTypeNamePluralCapital(props.offerType)}`}</SiteMapHeading>

                <SiteMapBox css={[mb(4)]}>
                    <SiteMapBox.Header as="h2" css={[ph(3)]}>
                        Oferty w podziale na miasta
                    </SiteMapBox.Header>
                    <SiteMapSubregionList offerType={props.offerType} subregionName="cities" regions={domesticRegions} regionAsLink />
                </SiteMapBox>

                <SiteMapBox css={[mb(4)]}>
                    <SiteMapBox.Header as="h2" css={[ph(3)]}>
                        Oferty w podziale na regiony
                    </SiteMapBox.Header>
                    <SiteMapSubregionList offerType={props.offerType} subregionName="aggregations" regions={domesticRegions} />
                </SiteMapBox>

                <SiteMapBox css={[mb(4)]}>
                    <SiteMapBox.Header as="h2" css={[ph(3)]}>
                        Oferty w podziale na powiaty
                    </SiteMapBox.Header>
                    <SiteMapSubregionList offerType={props.offerType} subregionName="counties" regions={domesticRegions} />
                </SiteMapBox>
                {props.offerType !== OfferType.COMMERCIAL && (
                    <SiteMapBox css={[mb(4)]}>
                        <SiteMapBox.Header as="h2" css={[ph(3)]}>
                            Oferty w Hiszpanii
                        </SiteMapBox.Header>
                        <SiteMapSubregionList offerType={props.offerType} subregionName="cities" regions={abroadRegions} country={Country.SPAIN} regionAsLink />
                    </SiteMapBox>
                )}
            </article>
        </Container>
    );
};
import React from "react";

import {Container} from "@pg-design/grid-module";
import {mb, ph} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../../app/components/breadcrumbs/BreadcrumbsItem";
import {getOfferTypeNamePluralCapital} from "../../../offer/helpers/OfferType";
import {OfferType} from "../../../offer/types/OfferType";
import {Country} from "../../../region/types/Country";
import {SiteMapBox} from "../../components/SiteMapBox";
import {SiteMapHeading} from "../../components/SiteMapHeading";
import {SiteMapSubregionList} from "../../components/SiteMapSubregionList";
import {useRegions} from "../../hooks/use_regions";
import {offerTypeUrl} from "../../utils/offer_type_url";

interface IProps {
    offerType: OfferType;
}

export const SiteMapOffersType = (props: IProps) => {
    const {domesticRegions, abroadRegions} = useRegions();

    return (
        <Container>
            <Breadcrumbs homePageUrl={rpAppLink.base()}>
                <BreadcrumbsItem name="Mapa strony" position="2" url={rpAppLink.siteMap.base()} />
                <BreadcrumbsItem
                    isLinkingToCurrentLocation
                    name={`Mapa strony - ${getOfferTypeNamePluralCapital(props.offerType)}`}
                    position="3"
                    url={offerTypeUrl(props.offerType)}
                />
            </Breadcrumbs>

            <article>
                <SiteMapHeading>{`Mapa strony - ${getOfferTypeNamePluralCapital(props.offerType)}`}</SiteMapHeading>

                <SiteMapBox css={[mb(4)]}>
                    <SiteMapBox.Header as="h2" css={[ph(3)]}>
                        Oferty w podziale na miasta
                    </SiteMapBox.Header>
                    <SiteMapSubregionList offerType={props.offerType} subregionName="cities" regions={domesticRegions} regionAsLink />
                </SiteMapBox>

                <SiteMapBox css={[mb(4)]}>
                    <SiteMapBox.Header as="h2" css={[ph(3)]}>
                        Oferty w podziale na regiony
                    </SiteMapBox.Header>
                    <SiteMapSubregionList offerType={props.offerType} subregionName="aggregations" regions={domesticRegions} />
                </SiteMapBox>

                <SiteMapBox css={[mb(4)]}>
                    <SiteMapBox.Header as="h2" css={[ph(3)]}>
                        Oferty w podziale na powiaty
                    </SiteMapBox.Header>
                    <SiteMapSubregionList offerType={props.offerType} subregionName="counties" regions={domesticRegions} />
                </SiteMapBox>
                {props.offerType !== OfferType.COMMERCIAL && (
                    <SiteMapBox css={[mb(4)]}>
                        <SiteMapBox.Header as="h2" css={[ph(3)]}>
                            Oferty w Hiszpanii
                        </SiteMapBox.Header>
                        <SiteMapSubregionList offerType={props.offerType} subregionName="cities" regions={abroadRegions} country={Country.SPAIN} regionAsLink />
                    </SiteMapBox>
                )}
            </article>
        </Container>
    );
};
